export const selectCurrentUser = state => {
    return state.auth.user;
};

export const getCurrentUserId = state => {
    return state.auth.user.uid;
};